export default angular
  .module('doxy.common.services.fileService', [])
  .service('fileService', function () {
    function downloadURI(uri) {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('style', 'width: 0; height: 0; visibility: hidden;');
      iframe.src = uri;
      document.body.appendChild(iframe);
      setTimeout(() => document.body.removeChild(iframe), 60 * 1000);
    }

    return {
      downloadURI,
    };
  }).name;
